import Extract from '../components/Extract/Extract'

let routes = {
    path: '/extract',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
      {
          path: '/extract',
          name: 'Extrações',
          component: Extract
      },
    ]
}

export default routes



// WEBPACK FOOTER //
// ./src/router/extract.js